/**
 * standTalepService.js — Firma tarafı stand bazlı talep verisi
 *
 * Route: /Firma/Talepler/:standId (FirmaTalepStandDetailPage.jsx), aggregated
 * across all stands by /Firma/Talepler (firmaTalepListService.js).
 * Base URL (future): https://gw.sakagrup.com:8443/api/v1/stands/talepler
 * Auth: getAuthHeader() — Basic Auth + X-user-Id + X-token
 *
 * standOverviewService.js'ten ayrı bir dosya: bu, proje evrakları/onay verisinden
 * bağımsız bir alan. Dört alt alanı var (2026-07-15 revizyonu ile /fromImageToLayout
 * referans görseline göre yeniden sınıflandırıldı — eskiden "Genel Talepler" tek
 * sekmede Elektrik...Güvenlik'in 8'ini birden taşıyordu, "Teknik Talepler" sekmesi de
 * yanlışlıkla iş izinlerini gösteriyordu; artık adlandırma içerikle eşleşiyor):
 *  - Teknik Talepler (Elektrik/Su/Hava/İnternet) — miktar bazlı, onay akışı yok,
 *    her zaman 4'ü de gösterilir (talep edilmemiş olsa bile gri).
 *  - Hizmet Talepleri (24 Saat Elektrik/Temizlik/Host-Hostes/Güvenlik) — onay
 *    durumu (TALEP_STATUS) taşır.
 *  - İş İzin Talepleri (Makine/Gösteri/Pişirme/Sıvı/Sıcak/Hayvan/Kesici/Silah) — onay
 *    durumu taşır. (Sekme adı eskiden yanlışlıkla "Teknik Talepler"ydi.)
 *  - Ekipman Talepleri — kategori listesi yok, stand başına tek kalem (hasRequest +
 *    onay durumu) — "muhtemelen tek şey" olduğu için ayrı bir kategori dizisi
 *    yerine tekil bir GET.
 *  - Borç durumu (Alan/Teknik/Ekipman) — "Talepler Borç Durumu" sekmesinde gösterilir.
 * Diğer sekmeler (Talep Bilgileri, Ekipman Talebi) henüz doldurulmadı — referans
 * görsel geldikçe /fromImageToLayout ile eklenecek.
 *
 * 2026-07-23 revizyonu (talep oluşturma popup'ı): Hizmet/İş İzin/Ekipman Talepleri
 * artık ortak bir talep formu üzerinden oluşturuluyor (bkz. FirmaTalepStandDetailPage.jsx
 * — TalepOlusturModal), Teknik Talepler hariç (o hâlâ belge yükleme + kroki çıkış
 * noktası ile ayrı bir akış, bu revizyonun kapsamı dışında). Bu üçünün eski ayrı
 * alan şekilleri (Hizmet'in `schedule`, İş İzni'nin serbest metin `title`, Ekipman'ın
 * `quantity`) kaldırıldı — hepsi aynı ortak alan setini taşıyor:
 *  { kvkkAccepted, startDate, endDate, sergilenecekUrun, yapilacakIs, operator,
 *    personnelDocs: [{ name }], ekipmanMalzemeListesi, isOzeti, riskler }
 * bkz. createHizmetTalebi/createIsIzinTalebi/createEkipmanTalebi.
 *
 * 2026-07-23 revizyonu (Teknik Talep belge + çıkış noktası): yukarıdaki notta
 * kapsam dışı bırakılan Teknik Talepler akışı eklendi. Her kategori kaydına artık
 * `exitPoint: {x,y}|null` alanı eşlik ediyor (kroki SVG viewBox'ına göre normalize
 * koordinat) — belge (standOverviewService.js'teki standFileId 3, "Teknik Talep
 * Planı") FirmaProjelerListPage.jsx/FirmaStandDetailPage.jsx'teki "Proje Dosyaları"
 * sekmesinden VEYA FirmaTalepStandDetailPage.jsx'teki TeknikTalepModal'dan
 * yüklenebilir (aynı stand.uploadedFiles kaydı, iki giriş noktası). Belge var
 * olmadan çıkış noktası girilemez (bkz. TeknikTalepModal'daki gate). Elektrik'in
 * çıkış noktası ayrıca FirmaStandDetailPage.jsx'teki "Proje Bilgiler" sekmesinden de
 * (sadece Elektrik) girilebilir — iki sayfa da aynı setTeknikExitPoint'e yazar.
 * createTeknikTalebi, belge yüklendiğinde (çıkış noktası opsiyonel) o kategoriyi
 * hasRequest:true yapar — Hizmet/İş İzni/Ekipman'daki KVKK/tarih formu yok, belge
 * yüklenmesi talebin kendisini tamamlar.
 *
 * 2026-08-10 revizyonu (mock→backend reconciliation, /Firma/Talepler tarafı):
 * bkz. docs/guides/FE-StandTalepRequestController-guide.md ve
 * FE-StandTalepController-guide.md §5 (Borç). GET/POST/PUT fonksiyonlarına
 * util/knowledgebase/local-backend-testing.md'deki paylaşımlı-servis `forceLive`
 * deseniyle (varsayılan false, davranış diğer çağıranlar için — FirmaStandDetailPage.jsx,
 * FirmaStandOverviewPage.jsx, FirmaProjelerListPage.jsx'in declareTeknikTalepler'i —
 * aynen kalır) canlı dal eklendi. Test verisi: fuar 298, stand 57552 (mock fixture,
 * bkz. FE-README-guide.md "Known-good test data"). `getBorcDurumu` FARKLI bir uç
 * kullanır (`/api/v1/standTalep/borcDurumu/{id}`, bu dosyanın BASE'i (`/stands/talepler`)
 * DEĞİL — guide'ın "Built elsewhere" notu) ve zarfın `categories` alanını döner, diğer
 * alanlar (hasDebt/legacyDebtWarning/legacyDebtFlags) şimdilik kullanılmıyor (bkz. o
 * fonksiyonun kendi yorumu). `setTeknikExitPoint` ve Teknik Talep belge yükleme akışı
 * (TeknikTalepModal'daki uploadStandFile çağrısı) KASITLI OLARAK canlıya taşınmadı —
 * `PUT .../cikis-noktasi` backend'de hiç yok (guide "Asked for but not built #1"), ve
 * belge yükleme project-stand-listesi-reconciliation memory'sindeki bilinen fuar 298
 * zero-date bug'ına çarpıyor (`POST /projects/{id}/files` 500).
 */

import axios from 'axios';
import { JAVA_BACKEND_API_URL, getAuthHeader } from '../Components/Contexts/BackendConstants';
import i18n from "../i18n";
import { dosyaListesi } from './onayMetniService';

const BASE = `${JAVA_BACKEND_API_URL}/stands/talepler`;

// ─── MOCK MODU ────────────────────────────────────────────────────────────────
export const USE_MOCK_DATA = true; // Backend hazır olunca false yap

const mockDelay = (ms = 150) => new Promise((r) => setTimeout(r, ms));

// Backend hata gövdeleri tutarsız (bkz. FE-README-guide.md "wire conventions") —
// bazen düz metin, bazen {message,result,data} zarfı. projectService.js'teki
// parseError ile aynı desen, dosya-yerel kopya (standOverviewService.js de aynı
// deseni tekrarlıyor, ortak bir utils dosyası yok).
function parseError(error) {
  const message =
    typeof error.response?.data === 'string'
      ? error.response.data
      : error.response?.data?.message ?? error.message ?? i18n.t("services:standTalepService.bilinmeyenHata");
  const err = new Error(message);
  // #722: the backend's refusals carry a stable key next to the message (talep.metni_degisti, ...): a screen branches on it, not on the text
  err.status = error.response?.status ?? null;
  err.messageKey = error.response?.data?.messageKey ?? null;
  throw err;
}

// Renkler bu temanın derlenmiş SCSS token'larından alınmış sabit hex değerleridir
// (src/assets/scss/_variables.scss: $danger/$warning/$primary) — bu build'de Bootstrap'ın
// çalışma zamanı `--bs-*` CSS custom property'leri :root'ta tanımlı değil, bu yüzden
// `var(--bs-danger)` gibi bir referans sessizce boş kalır. Bootstrap className'leri
// (`bg-danger`, `<Badge color="danger">`) SCSS derlemesinden geldiği için etkilenmez.

/**
 * Teknik Talepler kategorileri — sabit metadata. Renk her zaman kategoriye bağlıdır
 * (referans görselde aynı kategori hep aynı renkte görünüyor); bir stand için o
 * kategori talep edilmemişse UI tarafında gri gösterilir. Onay akışı yok — bu
 * yüzden bu dört kalem hem liste kartında hem detay sekmesinde talep edilmemiş
 * olsa da her zaman görünür kalır.
 *
 * 2026-07-23 revizyonu: sadece Elektrik miktar bazlı kaldı (kW) — Su/Hava/İnternet
 * için firma artık bir miktar girmiyor, sadece talep edip etmediğini (evet/hayır)
 * işaretliyor (`type: 'boolean'`). `quantity` alanı bu üç kategoride artık hiç
 * dolmaz — TalepQuantityCard (FirmaTalepStandDetailPage.jsx) ve CreateProjectModal
 * (FirmaProjelerListPage.jsx) `type`'a göre dallanır.
 */
export const TEKNIK_TALEP_KATEGORILERI = [
  { key: 'elektrik', get label() { return i18n.t("services:standTalepService.elektrik"); }, type: 'quantity', color: '#178f8f' },
  { key: 'su', get label() { return i18n.t("services:standTalepService.su"); }, type: 'boolean', color: '#f06548' },
  { key: 'hava', get label() { return i18n.t("services:standTalepService.hava"); }, type: 'boolean', color: '#f7b84b' },
  { key: 'internet', get label() { return i18n.t("services:standTalepService.internet"); }, type: 'boolean', color: '#178f8f' },
];

/**
 * Hizmet Talepleri kategorileri — sabit metadata. Ortak talep formuyla oluşturulur
 * (bkz. dosya başı 2026-07-23 notu), onay durumu rozetli (TALEP_STATUS). Miktar
 * bazlı Teknik Talepler'in aksine talep edilmemiş kalemler liste kartında/araç
 * çubuğunda gösterilmez (bkz. dosya başı yorumu).
 */
export const HIZMET_TALEP_KATEGORILERI = [
  { key: '24saatElektrik', get label() { return i18n.t("services:standTalepService.n24SaatElektrik"); }, type: 'schedule', color: '#178f8f' },
  { key: 'temizlik', get label() { return i18n.t("services:standTalepService.temizlik"); }, type: 'schedule', color: '#178f8f' },
  { key: 'hostHostes', label: 'Host/Hostes', type: 'schedule', color: '#405189' },
  { key: 'guvenlik', get label() { return i18n.t("services:standTalepService.guvenlik"); }, type: 'schedule', color: '#f7b84b' },
];

// 0=Bekliyor, 1=Onaylı, 2=Reddedildi — standOverviewService.js'teki FILE_APPROVAL_STATUS
// ile aynı şekil, referans görseldeki Türkçe etiketlerle (Onaylı/Bekliyor) eşleşsin diye
// ayrı tutuldu. `hex`, İş İzni/Ekipman kartlarındaki ikon karesinin durum bazlı rengi
// için — `color` (bootstrap token) rozetlerde (<Badge color="...">) kullanılmaya devam eder.
export const TALEP_STATUS = {
  0: { get label() { return i18n.t("services:standTalepService.bekliyor"); }, color: 'warning', hex: '#f7b84b' },
  1: { get label() { return i18n.t("services:standTalepService.onayli"); }, color: 'success', hex: '#178f8f' },
  2: { get label() { return i18n.t("services:standTalepService.reddedildi"); }, color: 'danger', hex: '#f06548' },
  // #696 (backend #695): a company's Teknik request that is saved but not sent for approval yet; only Teknik rows ever carry it.
  4: { get label() { return i18n.t("services:standTalepService.taslak"); }, color: 'secondary', hex: '#878a99' },
};

// Mock kayıtlar — standOverviewService.js'teki "Test Decorator" (dekoratorFirmaId 500)
// müşteri roster'ıyla aynı stand id'lerine (mongo-style .id) bağlı. categoryKey,
// TEKNIK_TALEP_KATEGORILERI/HIZMET_TALEP_KATEGORILERI'nin hangisine ait olduğunu
// belirler — tek bir dizide tutulup getTeknikTalepler/getHizmetTalepleri ile
// filtrelenir, veri kaynağı tekilliği için ayrı diziye bölünmedi.
const _mockTalepler = {
  '665f1a2b3c4d5e6f7a8b9c24': [ // A-201, Çarşıbaşı Kozmetik — hasDebt: false
    // exitPoint'ler kasıtlı olarak dolduruldu — FirmaStandOverviewPage.jsx'teki
    // "Konum" sekmesinin (Standı Gör) çok kategorili nokta gösterimini örneklemek
    // için (bkz. StandKrokiView). Hava exitPoint:null bırakıldı ki "talep var ama
    // nokta henüz girilmemiş" durumu da bir örnekte kalsın.
    { categoryKey: 'elektrik', hasRequest: true, quantity: { value: 10, unit: 'kW' }, exitPoint: { x: 0.3, y: 0.3 } },
    { categoryKey: 'su', hasRequest: true, exitPoint: { x: 0.75, y: 0.35 } },
    { categoryKey: 'hava', hasRequest: true, exitPoint: null },
    { categoryKey: 'internet', hasRequest: true, exitPoint: { x: 0.5, y: 0.8 } },
    // Hizmet Talepleri tam dolu (2/2 — liste kartındaki rezerve alan taşmadan doluyor).
    {
      categoryKey: '24saatElektrik', hasRequest: true, status: 1, kvkkAccepted: true,
      startDate: '2026-09-12', endDate: '2026-09-14', sergilenecekUrun: '', operator: '',
      yapilacakIs: 'Gece boyunca kesintisiz elektrik ihtiyacı', personnelDocs: [],
      ekipmanMalzemeListesi: '', isOzeti: 'Stand içi soğutucu ünitelerin gece de çalışması için 7/24 elektrik talebi.',
      riskler: 'Elektrik kesintisinde ürün bozulma riski — yedek jeneratör bağlantısı hazır bulundurulacaktır.',
    },
    {
      categoryKey: 'temizlik', hasRequest: true, status: 1, kvkkAccepted: true,
      startDate: '2026-09-15', endDate: '2026-09-15', sergilenecekUrun: '', operator: '',
      yapilacakIs: 'Günlük genel temizlik', personnelDocs: [],
      ekipmanMalzemeListesi: 'Endüstriyel temizlik makinesi', isOzeti: 'Fuar günü sabah açılıştan önce standın genel temizliği.',
      riskler: 'Islak zeminde kayma riski — uyarı levhaları konulacaktır.',
    },
    { categoryKey: 'hostHostes', hasRequest: false },
    { categoryKey: 'guvenlik', hasRequest: false },
  ],
  '665f1a2b3c4d5e6f7a8b9c25': [ // B-11, ABC Tekstil — hasDebt: true
    { categoryKey: 'elektrik', hasRequest: true, quantity: { value: 6, unit: 'kW' }, exitPoint: null },
    { categoryKey: 'su', hasRequest: false, exitPoint: null },
    { categoryKey: 'hava', hasRequest: false, exitPoint: null },
    { categoryKey: 'internet', hasRequest: true, exitPoint: null },
    // Hizmet Talepleri kasıtlı olarak sadece 1/2 dolu — liste kartındaki 2 kutuluk
    // rezerve alanın 1 dolu + 1 boş + soluk gri ayraç halini gösteren örnek.
    { categoryKey: '24saatElektrik', hasRequest: false },
    { categoryKey: 'temizlik', hasRequest: false },
    {
      categoryKey: 'hostHostes', hasRequest: true, status: 1, kvkkAccepted: true,
      startDate: '2026-09-12', endDate: '2026-09-13', sergilenecekUrun: '', operator: '',
      yapilacakIs: 'Karşılama ve yönlendirme hizmeti', personnelDocs: [],
      ekipmanMalzemeListesi: '', isOzeti: '2 kişilik host/hostes ekibi, Cuma ve Cumartesi günleri standda görevlendirilecek.',
      riskler: 'Yok.',
    },
    { categoryKey: 'guvenlik', hasRequest: false },
  ],
  '665f1a2b3c4d5e6f7a8b9c26': [ // C-19, DEF Mobilya — hasDebt: true, henüz hiç talep yok
    // Teknik Talepler her zaman 4'ü de döner (hasRequest:false dahi) — boş dizi
    // döndürülürse liste kartı 4 gri kareyi de kaybeder, bkz. dosya başı yorumu.
    { categoryKey: 'elektrik', hasRequest: false, exitPoint: null },
    { categoryKey: 'su', hasRequest: false, exitPoint: null },
    { categoryKey: 'hava', hasRequest: false, exitPoint: null },
    { categoryKey: 'internet', hasRequest: false, exitPoint: null },
  ],
};

/**
 * Bir standın Teknik Talepleri (Elektrik/Su/Hava/İnternet) — her zaman 4 kalem de
 * döner (hasRequest:false olanlar dahil), UI'da gri gösterilsin diye.
 * `id`, standOverviewService.getStandOverviewDetail ile aynı mongo-style stand id'sidir.
 * GET /stands/talepler/{id}/teknik
 */
export async function getTeknikTalepler(id, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    const teknikKeys = TEKNIK_TALEP_KATEGORILERI.map((c) => c.key);
    return (_mockTalepler[id] || []).filter((r) => teknikKeys.includes(r.categoryKey));
  }

  try {
    const response = await axios.get(`${BASE}/${id}/teknik`, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Error fetching teknik talepler:', error);
    parseError(error);
  }
}

/**
 * #710: standın ÇİZİLMİŞ ana hattı — şirket tarafındaki stand sayfalarının ("Standı Gör", köşe / Kuşbakışı kutucukları) ve Talepler sayfasının Teknik
 * sekmesinin sabit L şekli yerine çizdiği kroki. #676'nın proje anahtarlı `GET /projects/{id}/drawn-walls` cevabının STAND anahtarlı ikizi (aynı DTO): bir
 * Katılımcının standının proje kaydı hiç olmayabilir, bu yüzden `declaredHMax` yalnızca standın projesi varsa gelir. `id` SAYISAL stand id'sidir (mongo-tarzı
 * mock id'ler için çağrılmaz: çağıran taraf `etkin` ile kapatır). fdsVector'a çağrı yok.
 * GET /stands/talepler/{standId}/drawn-walls
 */
export async function getStandDrawnWalls(standId, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    return { drawn: false, standId: null, fuarId: null, shapeCount: 0, declaredHMax: null, drawnAreaM2: null, minAciklikYuzde: null, walls: [] };
  }

  try {
    const response = await axios.get(`${BASE}/${standId}/drawn-walls`, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Error fetching the stand drawn walls:', error);
    parseError(error);
  }
}

/**
 * Bir standın Hizmet Talepleri (24 Saat Elektrik/Temizlik/Host-Hostes/Güvenlik).
 * GET /stands/talepler/{id}/hizmet
 */
export async function getHizmetTalepleri(id, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    const hizmetKeys = HIZMET_TALEP_KATEGORILERI.map((c) => c.key);
    return (_mockTalepler[id] || []).filter((r) => hizmetKeys.includes(r.categoryKey));
  }

  try {
    const response = await axios.get(`${BASE}/${id}/hizmet`, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Error fetching hizmet talepleri:', error);
    parseError(error);
  }
}

/**
 * #453 (2026-10-17): bir standın taleplerinin DEĞİŞİKLİK GEÇMİŞİ (backend #452) — olay başına (bir kayıt = bir olay): yapan taraf (FIRMA / ORGANIZATOR / PERSONEL), firma,
 * kullanıcı (adı yalnızca görmesi gereken kişiye gelir), zaman ve değişen alanlar {alan, eski, yeni}; en yeni önce. Mock'u yok: yalnızca gerçek (sayısal) stand id'si için çağrılır.
 * `tur`: 'TEKNIK' | 'REQUEST' (boş = ikisi), `kategori`: categoryKey (tur ister).
 * GET /stands/talepler/{id}/gecmis
 */
export async function getTalepGecmisi(standId, { tur = '', kategori = '' } = {}) {
  try {
    const params = {};
    if (tur) params.tur = tur;
    if (kategori) params.kategori = kategori;
    const response = await axios.get(`${BASE}/${standId}/gecmis`, { headers: getAuthHeader(), params });
    return response.data;
  } catch (error) {
    console.error('Error fetching talep gecmisi:', error);
    parseError(error);
  }
}

/**
 * İş İzin Talepleri kategorileri — sabit metadata, tek tip kart (renk kategoriye değil
 * talebin onay durumuna bağlı, bkz. IsIzinCard/TALEP_STATUS[status].hex). Detay
 * sayfasındaki sekme eskiden yanlışlıkla "Teknik Talepler" adını taşıyordu.
 */
export const IS_IZNI_KATEGORILERI = [
  { key: 'makine', get label() { return i18n.t("services:standTalepService.makine"); } },
  { key: 'gosteri', get label() { return i18n.t("services:standTalepService.gosteri"); } },
  { key: 'pisirme', get label() { return i18n.t("services:standTalepService.pisirme"); } },
  { key: 'sivi', get label() { return i18n.t("services:standTalepService.sivi"); } },
  { key: 'sicak', get label() { return i18n.t("services:standTalepService.sicak"); } },
  { key: 'hayvan', get label() { return i18n.t("services:standTalepService.hayvan"); } },
  { key: 'kesici', get label() { return i18n.t("services:standTalepService.kesici"); } },
  { key: 'silah', get label() { return i18n.t("services:standTalepService.silah"); } },
];

// Mock kayıtlar — aynı üç stand id'si. Ortak talep formuyla oluşturulur (bkz. dosya
// başı 2026-07-23 notu) — kart üzerindeki başlık artık `yapilacakIs` alanından gelir
// (eskiden ayrı bir serbest metin `title` alanıydı, kaldırıldı).
const _mockIsIzinleri = {
  '665f1a2b3c4d5e6f7a8b9c24': [ // A-201 — referans görselle aynı üç talep + durum
    {
      categoryKey: 'makine', hasRequest: true, status: 1, kvkkAccepted: true,
      startDate: '2026-09-12', endDate: '2026-09-14', sergilenecekUrun: 'CNC işleme tezgahı',
      yapilacakIs: 'Makine Sergilenmesi', operator: 'Ahmet Yılmaz',
      personnelDocs: [{ name: 'operator_belgesi.pdf' }, { name: 'periyodik_kontrol.pdf' }],
      ekipmanMalzemeListesi: '1 adet CNC tezgah, elektrik panosu',
      isOzeti: 'Fuar süresince tezgahın çalışır halde sergilenmesi.',
      riskler: 'Hareketli parçalarla temas riski — güvenlik bariyeri ve uyarı levhası kullanılacaktır.',
    },
    {
      categoryKey: 'gosteri', hasRequest: true, status: 0, kvkkAccepted: true,
      startDate: '2026-09-13', endDate: '2026-09-13', sergilenecekUrun: 'Kozmetik ürün serisi',
      yapilacakIs: 'Gösteriler', operator: 'Elif Kaya',
      personnelDocs: [{ name: 'hijyen_sertifikasi.pdf' }],
      ekipmanMalzemeListesi: 'Ses sistemi, sunum standı',
      isOzeti: 'Ürün tanıtım gösterisi, günde 2 seans.',
      riskler: 'Gösteri sırasında kalabalık birikmesi — geçiş alanı sınırlandırılacaktır.',
    },
    {
      categoryKey: 'pisirme', hasRequest: true, status: 1, kvkkAccepted: true,
      startDate: '2026-09-12', endDate: '2026-09-14', sergilenecekUrun: '',
      yapilacakIs: 'Pişirme', operator: 'Mehmet Demir',
      personnelDocs: [{ name: 'hijyen_egitim_sertifikasi.pdf' }],
      ekipmanMalzemeListesi: 'Taşınabilir ocak',
      isOzeti: 'Standda canlı yemek pişirme demosu.',
      riskler: 'Açık ateş/yangın riski — yangın söndürme ekipmanı hazır bulundurulacak, salon yönetiminden onay alınmıştır.',
    },
    { categoryKey: 'sivi', hasRequest: false },
    { categoryKey: 'sicak', hasRequest: false },
    { categoryKey: 'hayvan', hasRequest: false },
    { categoryKey: 'kesici', hasRequest: false },
    { categoryKey: 'silah', hasRequest: false },
  ],
  '665f1a2b3c4d5e6f7a8b9c25': [ // B-11 — farklı kategori/durum kombinasyonu
    { categoryKey: 'makine', hasRequest: false },
    { categoryKey: 'gosteri', hasRequest: false },
    { categoryKey: 'pisirme', hasRequest: false },
    { categoryKey: 'sivi', hasRequest: false },
    {
      categoryKey: 'sicak', hasRequest: true, status: 1, kvkkAccepted: true,
      startDate: '2026-09-14', endDate: '2026-09-14', sergilenecekUrun: 'Isıl işlem ürünleri',
      yapilacakIs: 'Ateş Gösterisi', operator: 'Kemal Öz',
      personnelDocs: [{ name: 'guvenli_kullanim_talimati.pdf' }],
      ekipmanMalzemeListesi: 'Yangın tüpü, gösteri düzeneği',
      isOzeti: 'Kısa süreli ateş gösterisi.',
      riskler: 'Yangın riski — yangın tüpü hazır bulundurulacak, güvenlik mesafesi korunacaktır.',
    },
    {
      categoryKey: 'hayvan', hasRequest: true, status: 0, kvkkAccepted: true,
      startDate: '2026-09-12', endDate: '2026-09-14', sergilenecekUrun: 'Canlı hayvan sergisi',
      yapilacakIs: 'Canlı Hayvan Sergisi', operator: 'Ayşe Yıldız',
      personnelDocs: [{ name: 'veteriner_onay_belgesi.pdf' }],
      ekipmanMalzemeListesi: 'Kafes/vitrin, havalandırma',
      isOzeti: 'Standda küçük ölçekli canlı hayvan sergisi.',
      riskler: 'Ziyaretçi teması riski — bariyerli vitrin kullanılacaktır.',
    },
    {
      categoryKey: 'kesici', hasRequest: true, status: 1, kvkkAccepted: true,
      startDate: '2026-09-12', endDate: '2026-09-14', sergilenecekUrun: 'Kesici el aletleri',
      yapilacakIs: 'Kesici Alet Sergilenmesi', operator: 'Burak Şahin',
      personnelDocs: [{ name: 'operator_belgesi.pdf' }],
      ekipmanMalzemeListesi: 'Vitrin dolabı',
      isOzeti: 'Ürünlerin sabit vitrinde sergilenmesi, kullanım demosu yok.',
      riskler: 'Kesici temasi riski — ürünler kilitli vitrinde sergilenecektir.',
    },
    {
      categoryKey: 'silah', hasRequest: true, status: 2, kvkkAccepted: true,
      startDate: '2026-09-12', endDate: '2026-09-14', sergilenecekUrun: 'Av malzemeleri',
      yapilacakIs: 'Silah Sergilenmesi', operator: 'Burak Şahin',
      personnelDocs: [{ name: 'ruhsat_belgesi.pdf' }],
      ekipmanMalzemeListesi: 'Kilitli vitrin',
      isOzeti: 'Av malzemelerinin sergilenmesi.',
      riskler: 'Mevzuat kısıtlaması nedeniyle talep reddedilmiştir.',
    },
  ],
  '665f1a2b3c4d5e6f7a8b9c26': [], // C-19 — henüz hiç iş izni talebi yok
};

/**
 * Bir standın İş İzin Talepleri (Makine/Gösteri/Pişirme/Sıvı/Sıcak/Hayvan/Kesici/Silah).
 * GET /stands/talepler/{id}/is-izinleri
 */
export async function getIsIzinleri(id, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    return _mockIsIzinleri[id] || [];
  }

  try {
    const response = await axios.get(`${BASE}/${id}/is-izinleri`, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Error fetching iş izinleri:', error);
    parseError(error);
  }
}

/**
 * Staff tarafı — bir talebi onaylar/reddeder (backlog #69(4): daha önce hiçbir yerden
 * çağrılmıyordu). status: 1 Onayla, 2 Reddet (rejectReason ile); 0 = Bekliyor'a geri al
 * (yalnızca Onaylı bir talebi yeniden açmak için — bkz. backend StandTalepRequestController
 * yorum satırı). categoryKey'e göre değil doğrudan requestId'ye göre çalışır, bu yüzden
 * İş İzni/Hizmet/Ekipman/Teknik talep gruplarının hepsinde aynı fonksiyon kullanılabilir.
 * PATCH /stands/talepler/{standId}/talepler/{requestId}/review
 */
export async function reviewTalepRequest(standId, requestId, status, rejectReason = null) {
  try {
    const response = await axios.patch(
      `${BASE}/${standId}/talepler/${requestId}/review`,
      { status, rejectReason },
      { headers: getAuthHeader() },
    );
    return response.data;
  } catch (error) {
    console.error('Error reviewing talep:', error);
    parseError(error);
  }
}

// Mock kayıtlar — Ekipman Talepleri kategori listesi yok (bkz. dosya başı yorumu),
// stand başına tek kalem. Ortak talep formuyla oluşturulur (bkz. dosya başı 2026-07-23
// notu) — eski `quantity: {value, unit}` alanı kaldırıldı, istenen adet/miktar artık
// serbest metin olarak `ekipmanMalzemeListesi` içinde belirtiliyor.
const _mockEkipman = {
  '665f1a2b3c4d5e6f7a8b9c24': { // A-201 — Onaylı
    hasRequest: true, status: 1, kvkkAccepted: true,
    startDate: '2026-09-12', endDate: '2026-09-14', sergilenecekUrun: '', operator: '',
    yapilacakIs: 'Ek sandalye ve masa ihtiyacı', personnelDocs: [],
    ekipmanMalzemeListesi: '20 adet sandalye, 5 adet masa',
    isOzeti: 'Ziyaretçi karşılama alanı için ek oturma grubu.',
    riskler: 'Yok.',
  },
  '665f1a2b3c4d5e6f7a8b9c25': { // B-11 — Bekliyor
    hasRequest: true, status: 0, kvkkAccepted: true,
    startDate: '2026-09-12', endDate: '2026-09-14', sergilenecekUrun: '', operator: '',
    yapilacakIs: 'Vitrin dolabı ihtiyacı', personnelDocs: [],
    ekipmanMalzemeListesi: '10 adet kilitli vitrin dolabı',
    isOzeti: 'Sergilenecek ürünler için kilitli vitrin talebi.',
    riskler: 'Yok.',
  },
  '665f1a2b3c4d5e6f7a8b9c26': { hasRequest: false }, // C-19 — henüz talep yok
};

/**
 * Bir standın Ekipman Talebi — sabit kategori listesi olmadığından tekil bir
 * nesne döner (dizi değil): { hasRequest, status, ...ortak talep alanları }.
 * GET /stands/talepler/{id}/ekipman
 */
export async function getEkipmanTalebi(id, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    return _mockEkipman[id] || { hasRequest: false };
  }

  try {
    const response = await axios.get(`${BASE}/${id}/ekipman`, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Error fetching ekipman talebi:', error);
    parseError(error);
  }
}

/**
 * Borç Durumu kategorileri — sabit metadata (ikon eşlemesi FirmaTalepStandDetailPage.jsx'te,
 * diğer talep türlerindeki TALEP_ICONS/IS_IZNI_ICONS ile aynı ayrım).
 */
export const BORC_DURUMU_KATEGORILERI = [
  { key: 'alan', get label() { return i18n.t("services:standTalepService.alanBorcu"); } },
  { key: 'teknik', get label() { return i18n.t("services:standTalepService.teknikBorcu"); } },
  { key: 'ekipman', get label() { return i18n.t("services:standTalepService.ekipmanBorcu"); } },
];

// Hizmet Talepleri (24 Saat Elektrik/Temizlik/Host-Hostes/Güvenlik) kendi başına
// ayrı bir talep kategorisi olduğundan kendi borcu da olabilir. `BORC_DURUMU_KATEGORILERI`
// listesinin kendisine eklenmedi çünkü Talepler Listesi'ndeki kart rengini
// (FirmaTaleplerListPage.jsx'teki talepBorcRenk) ve FirmaAnasayfaListPage.jsx'teki
// "Talepler" widget'ının kutucuk rengini de besliyor — o iki tüketiciyi etkilemeden
// sadece "Talepler Borç Durumu" sekmesine eklemek istendi (2026-08-04, /revise-page).
// FirmaTalepStandDetailPage.jsx'teki BorcDurumuPanel bu sabiti BORC_DURUMU_KATEGORILERI'ne
// kendi render listesinde (BORC_DURUMU_TAB_KATEGORILERI) ekliyor. standDurumuService.js/
// Stand Durumu sekmesi zaten kategoriye göre filtrelemeden tüm `borcItems`'ı okuyordu,
// bu yüzden ondan etkilenmedi. _mockBorcDurumu kayıtlarında 'hizmet' categoryKey'i
// zaten vardı, getBorcDurumu olduğu gibi döner.
export const HIZMET_BORC_META = { key: 'hizmet', get label() { return i18n.t("services:standTalepService.hizmetBorcu"); } };

// Her kategori 3 durumdan birinde olabilir: 'odendi' (borç kapandı), 'bekliyor'
// (borç var, `amount` alanı ₺ tutarını taşır) veya 'yok' (bu kalemden hiç borç
// oluşmadı — "Ödeme Yok"). Hex'ler bu dosyadaki TALEP_STATUS ile aynı sabit
// paletten (bkz. dosya başındaki --bs-* yorumu); gri, FirmaTalepStandDetailPage.jsx'teki
// TALEP_GRAY ile aynı değer (o sabit sadece o dosyada tanımlı, burada literal tutuldu).
export const BORC_DURUMU_STATUS = {
  odendi: { get label() { return i18n.t("services:standTalepService.odemeTamamlandi"); }, hex: '#178f8f' },
  bekliyor: { get label() { return i18n.t("services:standTalepService.bekliyor"); }, hex: '#f06548' },
  yok: { get label() { return i18n.t("services:standTalepService.odemeYok"); }, hex: '#878a99' },
};

// Mock kayıtlar — standOverviewService.js'teki hasDebt bayrağıyla tutarlı: A-201
// (hasDebt: false) tüm kalemlerde temiz, B-11 ve C-19 (hasDebt: true) farklı
// kalemlerde borç taşıyor. Üç durumun üçü de (odendi/bekliyor/yok) en az bir
// kayıtta görünüyor.
const _mockBorcDurumu = {
  '665f1a2b3c4d5e6f7a8b9c24': [ // A-201 — hasDebt: false
    { categoryKey: 'alan', status: 'odendi' },
    { categoryKey: 'teknik', status: 'odendi' },
    { categoryKey: 'ekipman', status: 'yok' },
    { categoryKey: 'hizmet', status: 'odendi' },
  ],
  '665f1a2b3c4d5e6f7a8b9c25': [ // B-11 — hasDebt: true
    { categoryKey: 'alan', status: 'odendi' },
    { categoryKey: 'teknik', status: 'bekliyor', amount: 500 },
    { categoryKey: 'ekipman', status: 'yok' },
    { categoryKey: 'hizmet', status: 'bekliyor', amount: 300 },
  ],
  '665f1a2b3c4d5e6f7a8b9c26': [ // C-19 — hasDebt: true, birden çok kalemde borç
    { categoryKey: 'alan', status: 'bekliyor', amount: 750 },
    { categoryKey: 'teknik', status: 'yok' },
    { categoryKey: 'ekipman', status: 'bekliyor', amount: 250 },
    { categoryKey: 'hizmet', status: 'yok' },
  ],
};

/**
 * Bir standın Alan/Teknik/Ekipman(/Hizmet) borç durumu.
 * GET /stands/talepler/{id}/borc-durumu — bu uç tasks-2 sözleşmesinde ama backend'de
 * bu path altında YOK. Gerçek endpoint FARKLI bir controller'da yaşıyor (bkz. dosya
 * başı 2026-08-10 notu): `GET /api/v1/standTalep/borcDurumu/{id}` (BASE'siz, kendi
 * JAVA_BACKEND_API_URL'i), zarfı `{standId,fuarId,categories,hasDebt,legacyDebtWarning,
 * legacyDebtFlags}` — `categories[]` şekli (`{categoryKey,status,amount}`) mock'takiyle
 * bire bir aynı olduğundan sadece o alan döndürülüyor, panel/kart kodları değişmeden
 * çalışır. `legacyDebtWarning`/`legacyDebtFlags` şimdilik yüzeye çıkarılmıyor (guide
 * "ayrı bir uyarı göster" öneriyor — kapsam dışı, gelecekte /revise-page ile eklenebilir).
 */
export async function getBorcDurumu(id, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    return _mockBorcDurumu[id] || [];
  }

  try {
    const response = await axios.get(`${JAVA_BACKEND_API_URL}/standTalep/borcDurumu/${id}`, { headers: getAuthHeader() });
    return response.data?.categories || [];
  } catch (error) {
    console.error('Error fetching borç durumu:', error);
    parseError(error);
  }
}

// Elektrik için sabit birim — declareTeknikTalepler'de girilen miktara eklenir,
// mevcut mock kayıtlardaki value/unit örnekleriyle aynı (bkz. dosya başındaki
// _mockTalepler). Su/Hava/İnternet miktar taşımadığından (bkz. TEKNIK_TALEP_KATEGORILERI
// başındaki 2026-07-23 notu) birim tablosunda yer almıyor.
const TEKNIK_TALEP_UNITS = { elektrik: 'kW' };

/**
 * Firma tarafı — proje ilk kez deklare edilirken Teknik Talepler'i (Elektrik/Su/
 * Hava/İnternet) tek seferde kaydeder (bkz. FirmaProjelerListPage.jsx "Proje
 * Yükle" modalı). entries: { elektrik?, su?, hava?, internet? } — Elektrik için
 * sayısal bir miktar (kW, boşsa hasRequest:false), diğer üçü için boolean
 * (true/false, bkz. 2026-07-23 notu). Dört kalem her zaman birlikte yazılır,
 * getTeknikTalepler'in "her zaman 4 kalem" sözleşmesiyle tutarlı kalsın diye.
 * #696 (backend #695): the rows a company on the stand switches on come back as DRAFTS (`status` 4, `taslak: true`), not waiting for
 * approval until getTeknikGonderim says so and gonderTeknikTaslaklari sends them; resolves with the four rows.
 * PUT /stands/talepler/{id}/teknik
 */
export async function declareTeknikTalepler(id, entries = {}, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    const before = _mockTalepler[id] || [];
    // #696: like the backend (#695), a category switched on now is a draft (status 4); one that was already on keeps its status
    const draftStatus = (key) => {
      const prior = before.find((r) => r.categoryKey === key);
      return prior?.hasRequest ? { status: prior.status ?? 0, taslak: prior.status === 4 } : { status: 4, taslak: true };
    };
    _mockTalepler[id] = TEKNIK_TALEP_KATEGORILERI.map((c) => {
      const value = entries[c.key];
      if (c.type === 'quantity') {
        return value != null && value !== ''
          ? { categoryKey: c.key, hasRequest: true, quantity: { value: Number(value), unit: TEKNIK_TALEP_UNITS[c.key] }, ...draftStatus(c.key) }
          : { categoryKey: c.key, hasRequest: false };
      }
      return value ? { categoryKey: c.key, hasRequest: true, ...draftStatus(c.key) } : { categoryKey: c.key, hasRequest: false };
    });
    return _mockTalepler[id];
  }

  try {
    // Tam değiştirme — gövdede olmayan kategori hasRequest:false'a döner (bkz.
    // guide'ın "body optional, no body wipes all four" uyarısı). Bu fonksiyon her
    // zaman dördünü birden gönderir (entries çağıran taraftan zaten tam geliyor).
    const response = await axios.put(`${BASE}/${id}/teknik`, entries, { headers: getAuthHeader() });
    return response.data?.data;
  } catch (error) {
    console.error('Error declaring teknik talepler:', error);
    parseError(error);
  }
}

/**
 * #696 (backend #695): what the Teknik panel's Gönder button needs — the stand's drafts, whether it has its Kuşbakışı, what is missing.
 * `{ taslakSayisi, taslaklar: [categoryKey], kusbakisiVar, eksikler: ["KUSBAKISI" | "ELEKTRIK_KW"], gonderilebilir }`; KUSBAKISI is listed
 * even before there is a draft, `gonderilebilir` = at least one draft and nothing missing.
 * GET /stands/talepler/{id}/teknik/gonderim
 */
export async function getTeknikGonderim(id, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    // there is no project store behind the mock: the Kuşbakışı always counts as uploaded
    const taslaklar = (_mockTalepler[id] || []).filter((r) => r.hasRequest && r.status === 4);
    const eksikler = taslaklar.some((r) => r.categoryKey === 'elektrik' && !(r.quantity?.value > 0)) ? ['ELEKTRIK_KW'] : [];
    return {
      taslakSayisi: taslaklar.length, taslaklar: taslaklar.map((r) => r.categoryKey),
      kusbakisiVar: true, eksikler, gonderilebilir: taslaklar.length > 0 && eksikler.length === 0,
    };
  }

  try {
    const response = await axios.get(`${BASE}/${id}/teknik/gonderim`, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Error fetching teknik gönderim durumu:', error);
    parseError(error);
  }
}

/**
 * #696 (backend #695): sends every Teknik draft of the stand for approval (Taslak -> Bekliyor), no body; resolves with the four rows.
 * A 409 (nothing to send, or the Kuşbakışı / the Elektrik kW missing) writes nothing and rejects with an Error whose `eksikler` lists what is
 * missing (empty when there was simply no draft).
 * POST /stands/talepler/{id}/teknik/gonder
 */
export async function gonderTeknikTaslaklari(id, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    _mockTalepler[id] = (_mockTalepler[id] || []).map((r) => (r.hasRequest && r.status === 4 ? { ...r, status: 0, taslak: false } : r));
    return _mockTalepler[id].filter((r) => TEKNIK_TALEP_KATEGORILERI.some((c) => c.key === r.categoryKey));
  }

  try {
    const response = await axios.post(`${BASE}/${id}/teknik/gonder`, null, { headers: getAuthHeader() });
    return response.data?.data;
  } catch (error) {
    console.error('Error sending teknik taslakları:', error);
    const eksikler = error.response?.data?.data?.eksikler;
    try {
      parseError(error);
    } catch (hata) {
      hata.eksikler = Array.isArray(eksikler) ? eksikler : [];
      throw hata;
    }
  }
}

/**
 * Firma tarafı — Teknik Talep Formu belgesi yüklendiğinde (standOverviewService.js'teki
 * standFileId 3 dosyası, bkz. FirmaTalepStandDetailPage.jsx'teki TeknikTalepModal) bir
 * teknik kategoriyi "talep edildi" olarak işaretler. Hizmet/İş İzni/Ekipman'ın aksine
 * KVKK/tarih/risk alanları yok — belge yüklenmesi (çıkış noktası opsiyonel) talebin
 * kendisini tamamlar (bkz. 2026-07-23 notu, dosya başı). Mevcut quantity/exitPoint
 * korunur — yalnızca hasRequest true'ya çekilir.
 * PUT /stands/talepler/{id}/teknik/{categoryKey}/talep
 */
export async function createTeknikTalebi(id, categoryKey, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    const existing = _mockTalepler[id] || [];
    const idx = existing.findIndex((r) => r.categoryKey === categoryKey);
    // #696: switched on now = a draft, as the backend does since #695
    _mockTalepler[id] = idx >= 0
      ? existing.map((r, i) => (i === idx ? { ...r, hasRequest: true, ...(r.hasRequest ? {} : { status: 4, taslak: true }) } : r))
      : [...existing, { categoryKey, hasRequest: true, exitPoint: null, status: 4, taslak: true }];
    return { success: true };
  }

  try {
    const response = await axios.put(`${BASE}/${id}/teknik/${categoryKey}/talep`, null, { headers: getAuthHeader() });
    return response.data?.data;
  } catch (error) {
    console.error('Error creating teknik talebi:', error);
    parseError(error);
  }
}

/**
 * Firma tarafı — bir teknik kategorinin kroki üzerindeki çıkış noktasını kaydeder
 * (bkz. TeknikTalepModal/FirmaStandDetailPage.jsx'teki Elektrik-only kroki — aynı
 * çıkış noktası verisine her iki sayfadan da bu fonksiyonla yazılır). point:
 * { x, y } — kroki SVG viewBox'ına göre normalize koordinat (0-1 aralığı).
 * PUT /stands/talepler/{id}/teknik/{categoryKey}/cikis-noktasi
 *
 * KASITLI OLARAK forceLive almıyor — bu uç backend'de hiç yok (guide "Asked for but
 * not built #1": no column, no read, no write, kroki yeniden yazılana kadar ertelendi).
 * Her zaman mock kalır; bkz. dosya başı 2026-08-10 notu.
 */
export async function setTeknikExitPoint(id, categoryKey, point) {
  if (USE_MOCK_DATA) {
    await mockDelay();
    const existing = _mockTalepler[id] || [];
    const idx = existing.findIndex((r) => r.categoryKey === categoryKey);
    _mockTalepler[id] = idx >= 0
      ? existing.map((r, i) => (i === idx ? { ...r, exitPoint: point } : r))
      : [...existing, { categoryKey, hasRequest: false, exitPoint: point }];
    return { success: true };
  }

  try {
    const response = await axios.put(`${BASE}/${id}/teknik/${categoryKey}/cikis-noktasi`, point, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Error setting teknik exit point:', error);
    throw error;
  }
}

// Hizmet/İş İzin/Ekipman Talepleri'nin ortak formu (bkz. dosya başı 2026-07-23 notu,
// FirmaTalepStandDetailPage.jsx'teki TalepOlusturModal) her zaman yeni talep
// status:0 (Bekliyor) ile başlar — onay admin tarafına ait, ayrı bir akış.
function buildTalepRecord(categoryKey, payload) {
  const {
    kvkkAccepted = false, startDate = '', endDate = '', sergilenecekUrun = '',
    yapilacakIs = '', operator = '', personnelDocs = [], ekipmanMalzemeListesi = '',
    isOzeti = '', riskler = '',
  } = payload;
  return {
    categoryKey, hasRequest: true, status: 0, kvkkAccepted, startDate, endDate,
    sergilenecekUrun, yapilacakIs, operator, personnelDocs, ekipmanMalzemeListesi,
    isOzeti, riskler,
  };
}

/**
 * Firma tarafı — bir Hizmet Talebi kategorisi için yeni talep oluşturur (ortak talep
 * formu, bkz. dosya başı 2026-07-23 notu). `_mockTalepler[id]` Teknik Talepler'le
 * paylaşılan tek dizi olduğundan (bkz. dosya başı yorumu) diziyi declareTeknikTalepler
 * gibi TAMAMEN değiştirmek yerine sadece ilgili categoryKey'i günceller/ekler —
 * aksi halde o standın Teknik Talepleri (ve diğer Hizmet kalemleri) silinirdi.
 * POST /stands/talepler/{id}/hizmet/{categoryKey}
 */
export async function createHizmetTalebi(id, categoryKey, payload = {}, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    const record = buildTalepRecord(categoryKey, payload);
    const existing = _mockTalepler[id] || [];
    const idx = existing.findIndex((r) => r.categoryKey === categoryKey);
    _mockTalepler[id] = idx >= 0
      ? existing.map((r, i) => (i === idx ? record : r))
      : [...existing, record];
    return { success: true };
  }

  try {
    // personnelDocs kasıtlı olarak gönderilmiyor — backend'de upload endpoint'i yok,
    // TalepFormPayload zaten bu alanı kabul etmiyor (guide "Asked for but not built #2").
    const { personnelDocs, ...body } = payload;
    const response = await axios.post(`${BASE}/${id}/hizmet/${categoryKey}`, body, { headers: getAuthHeader() });
    return response.data?.data;
  } catch (error) {
    console.error('Error creating hizmet talebi:', error);
    parseError(error);
  }
}

/**
 * Firma tarafı — bir İş İzin Talebi kategorisi için yeni talep oluşturur (ortak
 * talep formu, bkz. dosya başı 2026-07-23 notu).
 * POST /stands/talepler/{id}/is-izinleri/{categoryKey}
 */
export async function createIsIzinTalebi(id, categoryKey, payload = {}, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    const record = buildTalepRecord(categoryKey, payload);
    const existing = _mockIsIzinleri[id] || [];
    const idx = existing.findIndex((r) => r.categoryKey === categoryKey);
    _mockIsIzinleri[id] = idx >= 0
      ? existing.map((r, i) => (i === idx ? record : r))
      : [...existing, record];
    return { success: true };
  }

  try {
    const { personnelDocs, ...body } = payload; // bkz. createHizmetTalebi'deki aynı not
    const response = await axios.post(`${BASE}/${id}/is-izinleri/${categoryKey}`, body, { headers: getAuthHeader() });
    return response.data?.data;
  } catch (error) {
    console.error('Error creating iş izin talebi:', error);
    parseError(error);
  }
}

/** Talep metninin okunmadan gönderildiği (400) ve metnin okunurken değiştiği (409) durumların backend mesaj anahtarları (#721). */
export const TALEP_METNI_HATASI = { OKUNMADI: 'talep.metni_okunmadi', DEGISTI: 'talep.metni_degisti' };

/**
 * Bir İş İzni / Hizmet kategorisinin talep formunda okunacak metni (#722, backend #721): STANDIN fuarında yürürlükteki sürüm, isteğin
 * dilinde (EN yoksa TR). Metni olmayan kategori için 204 döner ve burada `null` olur: modal bugünkü gibi, hiçbir şey sorulmaz.
 * GET /stands/talepler/{id}/{hizmet|is-izinleri}/{categoryKey}/metin → { onayMetniKey, surumId, surumNo, isRequired, baslik, icerik (HTML), languageId, dosyalar[] }
 * `kind`: 'hizmet' | 'isIzni'. Gönderirken sürümün `surumId`'si talep gövdesine `metinSurumId` olarak konur.
 */
export async function getTalepMetni(id, kind, categoryKey, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    return null; // mock modda talep metni yok
  }

  try {
    const grup = kind === 'hizmet' ? 'hizmet' : 'is-izinleri';
    const response = await axios.get(`${BASE}/${id}/${grup}/${categoryKey}/metin`, { headers: getAuthHeader() });
    if (response.status === 204 || !response.data) return null;
    return { ...response.data, dosyalar: dosyaListesi(response.data.dosyalar) };
  } catch (error) {
    console.error('Error fetching talep metni:', error);
    parseError(error);
  }
}

/**
 * Firma tarafı — Ekipman Talebi oluşturur (ortak talep formu, bkz. dosya başı
 * 2026-07-23 notu). Sabit kategori listesi olmadığından categoryKey almaz.
 * POST /stands/talepler/{id}/ekipman
 */
export async function createEkipmanTalebi(id, payload = {}, { forceLive = false } = {}) {
  if (USE_MOCK_DATA && !forceLive) {
    await mockDelay();
    _mockEkipman[id] = buildTalepRecord('ekipman', payload);
    return { success: true };
  }

  try {
    const { personnelDocs, ...body } = payload; // bkz. createHizmetTalebi'deki aynı not
    const response = await axios.post(`${BASE}/${id}/ekipman`, body, { headers: getAuthHeader() });
    return response.data?.data;
  } catch (error) {
    console.error('Error creating ekipman talebi:', error);
    parseError(error);
  }
}
